import './main-menu-organisations-item.component.scss';
import DefaultImage from "/assets/img/ic_no_avatar.svg";

export default {
  template: require('./main-menu-organisations-item.component.html'),
  controller: function ($routeParams, $t, $gl, $alert, $auth, OrganisationOwnerOrganisationsApi, vuiOrganisation) {
    'ngInject';

    const self = this;

    self.auth = $auth;
    self.actions = {};

    self.onSelectOrganisation = item => {
      self.actions.close();
    }

    self.getFullName = () => {
      if ($auth.user()) {
        return $auth.user().name + ' ' + $auth.user().surname;
      } else {
        return ''
      }
    }

    self.getOrgImage = org => {
      if (org && org.image) {
        return org.image.thumbnail;
      }

      return DefaultImage;
    };

    self.loadOrganisation = id => {
      $gl.show();
      OrganisationOwnerOrganisationsApi.getById({id: id},
        response => {
          self.currentOrganisation = response;
          vuiOrganisation.set(response);
          $gl.hide();
        },
        error => $alert.processError(error, $t('organisation_owner.select_organisation.loading_organisation_error_message')));
    }

    self.loadOrganisations = () => {
      $gl.show();
      OrganisationOwnerOrganisationsApi.getAll({page: self.page, size: 5},
        response => {
          response.forEach(item => {
            if (!item.image) {
              item.image = {thumbnail: DefaultImage};
            }
          });
          self.organisations = response;
          $gl.hide();
        },
        error => {
          $alert.processError(error, $t('organisation_owner.select_organisation.loading_organisations_error_message'));
        })
    }

    self.loadOrganisation($routeParams.orgId);
    self.loadOrganisations();
  }
};
